import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { isValidUUID } from '../../../utils/functions';

export interface IRegistrationAnalysisDocument {
  id: string;
  type: string;
  label: string;
  name: string;
  status: string;
  is_rejected: boolean;
  rejection_reason: string | null;
  analyzed_at: string | null;
  created_at: string;
}

export interface IRegistrationAnalysisResult {
  registration_id: string;
  registration_code: number;
  vacancy: string;
  registration_status: string;
  registration_rejected: boolean;
  registration_rejection_reason: string | null;
  registration_analyzed_at: string | null;
  rejected_documents_count: number;
  documents: IRegistrationAnalysisDocument[];
}

const getRegistrationAnalysisResult = async (
  registrationId: string,
  signal?: AbortSignal,
): Promise<IRegistrationAnalysisResult | null> => {
  if (!isValidUUID(registrationId)) return null;

  const response = await configApi.get<IRegistrationAnalysisResult>(
    `attachment/registration/${encodeURIComponent(registrationId)}/analysis-result/`,
    { signal },
  );
  return response.data;
};

export const useGetRegistrationAnalysisResult = (registrationId: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['registration_analysis_result', registrationId],
    queryFn: ({ signal }) => getRegistrationAnalysisResult(registrationId, signal),
    enabled: enabled && isValidUUID(registrationId),
    refetchOnWindowFocus: false,
    gcTime: 0,
    retry: false,
  });
};
